import React from "react";
import "./UserPage.css";

import { useIsAdmin } from "../../hooks/useIsAdmin";
import { useParams } from "react-router-dom";
import { loadUser } from "./reducer";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "./selectors";
import Flex from "../../components/Flex/Flex";
import Text from "../../components/Text/Text";
import dayjs from "dayjs";
import Table from "../../components/Table/Table";

const UserPage = React.memo(() => {
  useIsAdmin();

  const dispatch = useDispatch();

  const { id } = useParams();

  const user = useSelector(selectUser);

  React.useEffect(() => {
    if (id) {
      dispatch(loadUser(+id));
    }
  }, [dispatch, id]);

  if (!user) {
    return null;
  }

  return (
    <Flex
      className="UserPage"
      vertical
    >
      <Text size={4}>{user.user.email}</Text>
      <Table
        columns={[
          {
            title: "Дата",
            dataIndex: "date",
            render: x => <Text>{dayjs(x.date).format("YYYY-MM-DD")}</Text>,
          },
          {
            title: "Поисков",
            dataIndex: "searches",
          },
        ]}
        data={user.statistics || []}
        pagination={false}
      />
    </Flex>
  );
});

export default UserPage;
